import React from 'react';
import * as styles from './SuccessStory.module.scss';

const stories = [
  {
    logo: '/images/pijar-logo.svg',
    title: 'Enhancing User Flexibility & Interaction in Pijar Belajar',
    description: 'Increases in logins, engagement, and conversions for users',
    illustration: '/images/card-pijar.png',
    url: 'https://medium.com/@telkomdesign/enhancing-user-flexibility-and-interaction-in-pijar-belajar-3f155fdea54e'
  },
  {
    logo: '/images/bigbox-logo.svg',
    title: 'Elevating Visuals with Better BigBox Experience',
    description: 'Successfully improved visual and more efficient development time',
    illustration: '/images/card-bigbox.png',
    url: 'https://medium.com/@telkomdesign/cutting-costs-elevating-visuals-a-better-bigbox-experience-d5b33d3882b7'
  },
  {
    logo: '/images/netmonk-logo.svg',
    title: 'Boosting Experience of Netmonk Help Center',
    description: 'Accelerated task completion, and optimized development efficiency',
    illustration: '/images/card-netmonk.png',
    url: 'https://medium.com/@telkomdesign/boosting-efficiency-and-upgrading-the-look-of-netmonks-help-center-83cb6b717756'
  },
];

const SuccessStories = () => {
  return (
    <section className={styles.successStories}>
    <div className="bx--grid">
      <div className="bx--row">
        <div className="bx--col-lg-12">
          <h3 className={styles.successStoriesTitle}>Real Stories, Real Impact</h3>
          <p className={styles.successStoriesDescription}>
            Witness the impact of the Legion Design System on product success
          </p>
        </div>
      </div>
      <div>
        <div className="bx--row">
          {stories.map((story, index) => (
            <div className={`${styles.successContainers} bx--col-lg-4 bx--col-md-4 bx--col-sm-4`} key={index}>
              <a className={styles.successLink} href={story.url} target="_blank" rel="noopener noreferrer">
                <div className={styles.successCard}>
                  <img
                    src={story.illustration}
                    alt={`${story.title} illustration`}
                    className={styles.cardImage}
                  />
                  <div className={styles.cardText}>
                    <h4 className={styles.cardTitle}>{story.title}</h4>
                    <p className={styles.cardDescription}>{story.description}</p>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
    </section>
  );
};

export default SuccessStories;